<template>
  <div class="widthFull">
    <nav
      class="
        navbar navbar-expand-lg navbar-light
        custom-toggler
        align-items-center
        fixed-top
      "
      :class="{ 'fixed-top': scroll > vh }"
    >
      <div class="container-fluid">
        <router-link to="/" class="" v-scroll-to="{ el: '.main', offset: -35 }">
          <img
          v-if="vw<991"
            src="../../assets/images/logo.png"
            class="img-fluid logoMob animatedLogo ml-4"
            ref="mainNavLogo"
          />
          <img
          v-if="vw>991 && $route.path != '/'"
            src="../../assets/images/logo.png"
            class="img-fluid logoMob-fix animatedLogo ml-4"
            ref="mainNavLogo"
          />
        </router-link>
        <button
          class="ml-3 navbar-toggler"
          type="button"
          name="openNavButton"
          data-toggle="collapse"
          data-target="#navbar9"
          style="z-index: 10"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse align-l" id="navbar9">
          <ul class="navbar-nav nav-fill w-100 lastNavLink mb-5 mb-lg-0">
            <li
              v-if="isAuthenticated && moment(now,'DD-MM-YYYY') >= moment(start_intermedio,'DD-MM-YYYY')"
              class="nav-item"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
            >
              <a
                v-if="$route.path == '/'"
                href="#active"
                v-scroll-to="{ el: '#active', offset: -85 }"
                class="nav-link menuItem"
                >Registra richiesta di rimborso</a
              >
              <router-link
                v-else
                to="/#active"
                v-scroll-to="{ el: '#active', offset: -85 }"
                class="nav-link menuItem"
                :class="{ 'theme-1': $route.name == 'Contest' }"
                >Registra richiesta di rimborso</router-link
              >
            </li>
            <li
              v-if="isAuthenticated && moment(now,'DD-MM-YYYY') >= moment(start_intermedio,'DD-MM-YYYY')"
              class="nav-item"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
            >
              <a
                v-if="$route.path == '/'"
                href="#active"
                v-scroll-to="{ el: '#active', offset: -85 }"
                class="nav-link menuItem"
                >Promozioni attive</a
              >
              <router-link
                v-else
                to="/#active"
                v-scroll-to="{ el: '#active', offset: -85 }"
                class="nav-link menuItem"
                >Promozioni attive</router-link
              >
            </li>
            <li
              v-if="isAuthenticated && moment(now,'DD-MM-YYYY') >= moment(start_intermedio,'DD-MM-YYYY')"
              class="nav-item"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
            >
              <!--<a v-if="$route.path == '/'" href="#notActive" v-scroll-to="{ el: '#notActive', offset: -85 }" class="nav-link menuItem">Promozioni terminate</a>
						<span v-else v-on:click="scrollToNotActive()" class="nav-link menuItem">Promozioni terminate</span>-->
              <router-link
                class="nav-link menuItem"
                to="/"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <span class="nav-link menuItem" v-on:click="scrollToNotActive()"
                  >Promozioni terminate</span
                >
              </router-link>
            </li>
            <li v-if="!isAuthenticated" class="nav-item">
              <router-link
                class="nav-link text-right"
                to="/login"
                v-scroll-to="'.main'"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <strong class="menuItem">Login</strong>
              </router-link>
            </li>
            <li v-if="isProfileLoaded && moment(now,'DD-MM-YYYY') <= moment(start_intermedio,'DD-MM-YYYY')" class="nav-item">
              <a
                class="nav-link text-right"
                @click="logout"
                v-scroll-to="'.main'"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <strong class="menuItem">Esci</strong>
              </a>
            </li>
            <li v-if="isProfileLoaded && moment(now,'DD-MM-YYYY') >= moment(start_intermedio,'DD-MM-YYYY')" class="nav-item dropdown mr-0 pd-0">
              <a
                class="nav-link dropdown-toggle menuItem mr-0 pd-0"
                href="#"
                id="navbardrop"
                data-toggle="dropdown"
              >
                <font-awesome-icon
                  class="pointer mr-0 pd-0"
                  icon="user"
                  size="1x"
                />
                {{ nome }}
              </a>
              <div
                class="dropdown-menu"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <router-link 
                  class="dropdown-item menuItem"
                  to="/account"
                  v-scroll-to="'.main'"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                  ><span class="menuItem">Il Mio Profilo</span></router-link
                >
                <!--<router-link class="dropdown-item menuItem"  to="/receipts" v-scroll-to="'.main'" data-toggle="collapse" data-target=".navbar-collapse.show"><span class="menuItem">La Mia Area</span></router-link>-->
                <a class="dropdown-item pointer menuItem black" @click="logout"
                  ><span class="menuItem">Esci</span></a
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div
      class="container-fluid fixed cookieCont cookieBaner"
      v-if="!acceptCookies"
    >
      <div class="row justify-content-center">
        <div class="col-12 Regular pt-3 pb-3">
          Questo sito utilizza cookie di profilazione anche di terze parti, per
          inviare all’Utente pubblicità e servizi in linea con le Sue
          preferenze. Qualora l’Utente volesse sapere di più o gestire le
          proprie preferenze sui cookie, premi
          <a
            href="https://www.lierac.it/privacy-cookie-policy.html"
            target="_blank"
            class="pointer Medium underline"
          >
            qui.</a
          >
          <br />Cliccando
          <i class="pointer Medium underline" v-on:click="doAcceptCookies(1)"
            >accetto</i
          >
          - l’Utente acconsente all’uso dei cookie.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { AUTH_LOGOUT, SET_PROMOTION, GET_PROMOTIONS } from "actions/auth";
import { ACCEPT_COOKIES, USER_REQUEST } from "actions/user";
import axios from "axios";

const moment = require("moment");

export default {
  name: "navigation",
  components: {},
  data() {
    return {
      moment: require("moment"),
      vh: window.innerHeight,
      vw: window.innerWidth,
      scroll: window.pageYOffset,
      directory: process.env.DIRECTORY,
      consent: "",
      start_intermedio:process.env.START_INTERMEDIO,
      now:moment()
    };
  },

  methods: {
    checkSoftwareVersion() {
      console.log("CHECK VERSION SW ************");
      var version = localStorage.getItem("sw_version");

      if (!version) {
        console.log("VERSION NOT SAVED => " + version);
        version = false;
      } else {
        console.log("ACTUAL VERSION => " + version);
      }
      var data = {
        version: version,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      axios({
        url: process.env.ROOT_API + "api/checkSoftwareVersion",
        method: "POST",
        data: { data },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          if (resp.data.version) {
            console.log("SERVER VERSION => " + resp.data.version);
            if (version != resp.data.version) {
              localStorage.setItem("sw_version", resp.data.version);
              window.location.reload();
            }
          }
        })
        .catch((error) => {});
    },
    doAcceptCookies(value) {
      this.$store.dispatch(ACCEPT_COOKIES, value).then((resp) => {});
    },

    logout: function () {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },

    checkConsentPopUp: function () {
      var _vue = this;
      var text =
        '<p class="text-center Regular">Per poter continuare é necessario accettare l`informativa</p>';
        //https://www.lierac.it/privacy-cookie-policy.html
      //var text_ =
      //  '<a target="_blank" href="' +
      //  this.directory +
      //  '/privacy"><small class="underline text-center Bold">Se vuoi visualizzare l`informativa clicca <i class="underline">qui</i></small></a>';
      var text_ =
        '<a target="_blank" href="https://www.lierac.it/privacy-cookie-policy.html"><small class="underline text-center Bold">Se vuoi visualizzare l`informativa clicca <i class="underline">qui</i></small></a>';
      var Swal = this.$swal;
      Swal.fire({
        title: text,
        html: text_,
        showCancelButton: false,
        confirmButtonText: `Accetta`,
        allowOutsideClick: false,
        animation: false,
      }).then((result) => {
        this.checkConsent();
        /* Read more about isConfirmed, isDenied below */
        if (!result.value) {
          Swal.fire(
            "Non hai accettato l`informativa, per poter parteipare é necessario accettarla",
            "",
            "error"
          );
        }
      });
    },
    checkConsent: function () {
      var data = {
        tk: this.profile,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      axios({
        url: process.env.ROOT_API + "api/checkConsent",
        method: "POST",
        data: {
          data
        },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          if (resp.data.status == "consent_give") {
            if (this.$store.getters.isAuthenticated) {
              this.$store.dispatch(USER_REQUEST);
            }
          }
        })
        .catch((error) => {});
    },
    scrollToNotActive: function () {
      var _vue = this;
      setTimeout(function () {
        _vue.$scrollTo("#notActive", 700, { offset: -85 });
      }, 200);
    },
  },
  watch: {

    $route (to, from){
        this.checkSoftwareVersion();
    },
    getProfile: function (val) {
      this.consent = this.profile.consent;
      if (!this.profile.iban && this.consent == 1) {
        if (this.$route.path != "/iban") {
          if (process.env.HAS_IBAN_BEFORE_LOG ) this.$router.push("/iban");
        }
      } else if (this.consent == 0) {
        if (this.$route.path != "/privacy") {
          if (process.env.HAS_CONFIRM_POPUP) this.checkConsentPopUp();
        }
      }
    },
  },
  updated: function () {
    this.consent = this.profile.consent;
    if (this.consent) {
      if (!this.profile.iban && this.consent == 1) {
        if (this.$route.path != "/iban") {
          if (process.env.HAS_IBAN_BEFORE_LOG ) this.$router.push("/iban");
        }
      } else if (this.consent == 0) {
        if (this.$route.path != "/privacy") {
          if (process.env.HAS_CONFIRM_POPUP) this.checkConsentPopUp();
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "isAuthenticated",
      "isProfileLoaded",
      "acceptCookies",
      "promoOpen",
    ]),
    ...mapState({
      authLoading: (state) => state.auth.status === "loading",
      profile: (state) => state.user.profile,
      nome: (state) => `${state.user.profile.company}`,
    }),
  },

  mounted() {
    this.now = moment();
		 this.consent = this.profile.consent;
      if (!this.profile.iban && this.consent == 1) {
        if (this.$route.path != "/iban") {
          if (process.env.HAS_IBAN_BEFORE_LOG ) this.$router.push("/iban");
        }
      } else if (this.consent == 0) {
        if (this.$route.path != "/privacy") {
          if (process.env.HAS_CONFIRM_POPUP) this.checkConsentPopUp();
        }
      }
    window.onresize = () => {
      this.vw = window.innerWidth;
      this.vh = window.innerHeight;
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/navigation/index.vue